module.exports = __webpack_public_path__ + "img/confirmation-ilustra.150ddf3f.svg";